/** These are illustrative works, not client case studies or product UI. */
export function renderFreelanceProofMarkup(): string {
  return `
    <div class="creative-work" data-creative-showcase="freelance">
      <div class="creative-work__stage" data-creative-stage="freelance" role="img" aria-label="Живая предметная визуализация шарнирного светильника">
        <span class="creative-work__anchor" data-creative-cube-anchor aria-hidden="true"></span>
      </div>
      <div class="creative-work__caption">
        <div><strong>Предметная визуализация</strong><span>Демонстрационная предметная сцена</span></div>
        <p>Модель<span aria-hidden="true"> / </span>Материалы<span aria-hidden="true"> / </span>Анимация</p>
      </div>
    </div>`;
}

export function renderCapabilitiesProofMarkup(): string {
  return `
    <div class="creative-capabilities" data-creative-showcase="capabilities" data-creative-mode="modeling">
      <div class="creative-capabilities__choices" role="group" aria-label="Возможности Blender">
        <button type="button" data-creative-mode-choice="modeling" aria-pressed="true"><span>Моделирование</span><small>Форма и конструкция объекта</small></button>
        <button type="button" data-creative-mode-choice="materials" aria-pressed="false"><span>Материалы</span><small>Фактура, металл и отражения</small></button>
        <button type="button" data-creative-mode-choice="rigging" aria-pressed="false"><span>Риггинг и анимация</span><small>Связанное движение деталей</small></button>
        <button type="button" data-creative-mode-choice="lighting" aria-pressed="false"><span>Свет</span><small>Луч и рассеивание в воздухе</small></button>
        <button type="button" data-creative-mode-choice="physics" aria-pressed="false"><span>Физика</span><small>Столкновение и деформация</small></button>
      </div>
      <div class="creative-capabilities__stage" data-creative-stage="capabilities" role="img" aria-label="Авторская 3D лампа: форма, материалы, движение шарниров, объёмный свет и столкновение с кубиком">
        <span class="creative-work__anchor" data-creative-cube-anchor aria-hidden="true"></span>
      </div>
    </div>`;
}
